import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { clearTournamentResult } from '../redux/gameSlice';
import './KickedNotice.css';

const ordinal = (n) => {
    const s = ['th', 'st', 'nd', 'rd'];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
};

// Global popup shown when this player's multi-table Tournament run ends (bust, leave while
// running, or outright win — TOURNAMENT_RESULT), or when a scheduled tournament is cancelled
// (under-subscribed) and the buy-in is refunded. Reuses the kicked-notice styling; rendered at
// the app level so it survives the table teardown / return to the lobby.
const TournamentResultNotice = () => {
    const dispatch = useDispatch();
    const result = useSelector((state) => state.games.tournamentResult);

    if (!result) return null;

    const name = result.gameName || 'Tournament';
    const cancelled = result.cancelled;
    const won = result.place === 1 && !cancelled;
    const paid = result.payout > 0;

    let title;
    let subtext;
    if (cancelled) {
        title = 'Tournament cancelled';
        subtext = `${name} didn't get enough players — your ${result.payout} chip buy-in was refunded.`;
    } else if (won) {
        title = 'You won the tournament!';
        subtext = `${name} — ${result.payout} chips added to your balance.`;
    } else {
        title = `You finished ${ordinal(result.place)}`;
        subtext = paid
            ? `${name} — ${result.payout} chips added to your balance.`
            : `${name} — out of the money this time.`;
    }

    return (
        <div className="kicked-notice-overlay" onClick={() => dispatch(clearTournamentResult())}>
            <div className="kicked-notice-box" onClick={(e) => e.stopPropagation()}>
                <span className="kicked-notice-title">{title}</span>
                <span className="kicked-notice-subtext">{subtext}</span>
                <button className="kicked-notice-btn" onClick={() => dispatch(clearTournamentResult())}>
                    OK
                </button>
            </div>
        </div>
    );
};

export default TournamentResultNotice;
